export default __webpack_public_path__ + "static/media/vw_man.26af3744.jpg";